<script lang="ts">
  import { GiphyFetch } from "@giphy/js-fetch-api";
  import { Grid } from "@giphy/svelte-components";
  import giphylogo from "$assets/images/giphy/poweredbygiphy.png";
  import { PUBLIC_GIPHY_KEY } from "$env/static/public";

  const gf = new GiphyFetch(PUBLIC_GIPHY_KEY);

  export let query: string;
  export let command: ({ result }: { result: any }) => void;
  $$restProps; // prevent svelte unused props warning

  $: query = query.trim();

  const fetchGifs = (offset: number) => {
    if (query) {
      return gf.search(query, { offset, limit: 10 });
    }
    return gf.trending({ offset, limit: 10 });
  };
</script>

<div
  id="suggestion"
  class="group max-h-[400px] min-w-[400px] overflow-y-auto bg-white drop-shadow-lg dark:bg-gray-700"
>
  {#key query}
    <Grid
      width={400}
      columns={2}
      gutter={6}
      {fetchGifs}
      on:click={(e) => command({ result: e.detail.gif })}
    />
  {/key}
</div>
<img src={giphylogo} alt={""} class="w-24" />
